import httpClient from "@/_shared/http-client";
import { objectHelper, date } from "@/_shared/utils";

const getPurchaseOrder = async (id = 1) => {
  let results = {};
  let url = `/records/purchase_orders/${id}?join=clients`;
  await httpClient.get(url).then(({ data }) => (
    results = data
  ));
  return results;
};

export const purchaseOrderService = {
  get: getPurchaseOrder,
};



// WEBPACK FOOTER //
// ./src/stock/api-services/purchaseOrderService.js